export function assertSecureApiTransport(base: string, pageOrigin: string, localDevelopment: boolean): void {
  const url = new URL(base, pageOrigin);
  const page = new URL(pageOrigin);
  const loopback = (host: string) => ['localhost', '127.0.0.1', '[::1]'].includes(host);
  const secure = url.protocol === 'https:' && page.protocol === 'https:';
  const local = localDevelopment && loopback(url.hostname) && loopback(page.hostname)
    && ['http:', 'https:'].includes(url.protocol) && ['http:', 'https:'].includes(page.protocol);
  if ((!secure && !local) || url.username || url.password) {
    throw new Error('HTTPS is required for the dashboard and API.');
  }
}
